module.exports = __webpack_public_path__ + "static/media/vip_bg_5.bea94313.png";